import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { trackEvent as track } from '../utils/analytics';
import { AtnaHero } from '../components/atnaPage/AtnaHero';
import { AtnaChallenge } from '../components/atnaPage/AtnaChallenge';
import { AtnaHow } from '../components/atnaPage/AtnaHow';
import { AtnaTransform } from '../components/atnaPage/AtnaTransform';
import { AtnaFinalCTA } from '../components/atnaPage/AtnaFinalCTA';
import { AtnaClosing } from '../components/atnaPage/AtnaClosing';
export function Atna() {
  useEffect(() => {
    track('Page Viewed', {
      page: 'ATNA Assistant'
    });
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-8024" data-mp="2yic1k6rj4ax8">
      <Header data-id="element-8025" data-mp="2yilv24bs907o" />

      <main className="pt-[120px]" data-id="element-8026" data-mp="2yfzitrdy5wj4">
        {/* 1. PROMISE */}
        <AtnaHero data-id="element-8027" data-mp="193xgbwfpz66h" />

        {/* 2. CHALLENGE */}
        <AtnaChallenge data-id="element-8028" data-mp="1442pttzuwily" />

        {/* 3. PRODUCT WOW — from intent to action */}
        <AtnaHow data-id="element-8029" data-mp="1465qr92jrw5g" />

        {/* 4. OPERATIONAL TRANSFORMATION */}
        <AtnaTransform data-id="element-8030" data-mp="2nwozegwp57r6" />

        {/* 5–6. PLATFORM SYNTHESIS + OUTCOME */}
        <AtnaFinalCTA data-id="element-8031" data-mp="2stxgsfa0t7rd" />

        {/* 7. ACTION */}
        <AtnaClosing data-id="element-8032" data-mp="2sscoyxf3c2x7" />
      </main>

      <Footer data-id="element-8033" data-mp="2xttnima3rdam" />
    </div>;
}